module.exports = __webpack_public_path__ + "img/right_arrow.c643fe3c.svg";